<template>
    <div class="auth-layout">
        <div class="form-wrap">
            <div class="form-title text-h4 text-center text-bold">
                {{ title }}
            </div>
            <div class="form-description text-h6 text-center text-grey-100">
                {{ description }}
            </div>
            <slot />
        </div>

        <LangToggler />
    </div>
</template>

<script>
import LangToggler from '@/components/general/LangToggler.vue'

export default {
    name: 'AuthLayout',
    components: { LangToggler },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
.auth-layout {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: url('@/assets/images/auth-bg.jpg') no-repeat left bottom;
    background-size: cover;
}

.lang-toggler {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: $white;
}

.form-wrap {
    display: flex;
    flex-direction: column;
    padding: 3rem;
    background: $white;
    border-radius: $border-radius-xl;
    width: 28.125rem;
    max-width: 100%;
    margin: 1rem;
}

.form-title {
    margin-bottom: 0.5rem;
}

.form-description {
    margin-bottom: 1.25rem;
}

@media screen and (max-width: 575px) {
    .form-wrap {
        padding: 2rem;
    }
}
</style>
